import classNames from 'classnames'
import Gawd from 'web/lib/gawd'
import GalleryGawdItem from './GalleryGawdItem'

export type GalleryItemProps = {
  className?: string
  gawds: Gawd[]
  isWallet?: boolean
}

export default function GalleryGawdItems({ className="", gawds, isWallet = false }: GalleryItemProps) {
  return (
    <div id="gawds" className={classNames(`mt-8`, className)}>
      <ul
        role="list"
        className="grid grid-cols-1 gap-x-4 gap-y-6 md:grid-cols-2 sm:gap-x-6 lg:grid-cols-3 xl:gap-x-8"
        x-max={1}>
        {gawds.map((gawd, index) =>
          <GalleryGawdItem key={gawd.id() > 0 ? gawd.id() : `tmp${index}`} gawd={gawd} isWallet={isWallet} />
        )}
      </ul>
    </div>
  )
}
